import ArticlesList from './ArticlesList';
import RcsUtils from './utils/RcsUtils';
import Validator from './Validator';
import template from '../templates/container.pug';

/**
 * This class handle my Component.
 */
class RcsCorInfinityScrollComponent {
  render() {
    this.UUID = RcsUtils.getUUID();

    let validator = new Validator([
      {
        selector: '[data-continous-related-links]',
        type: 'elementExists'
      },
      {
        selector: this.UUID,
        type: 'notNull'
      }
    ]);

    try {
      validator.validate();
    } catch (e) {
      console.warn('[INFINITY SCROLL COMPONENT] Failed DOM Validation.');

      return;
    }

    this.renderTemplate();

    let infinityScroll = new ArticlesList({
      uuid: this.UUID
    });
    infinityScroll.init();
  }

  renderTemplate() {
    let containerHtml = template();
    let containerElement = document.querySelector('[data-continous-related-links]');
    containerElement.innerHTML = containerHtml;
  }
}

module.exports = RcsCorInfinityScrollComponent;



// WEBPACK FOOTER //
// ./src/rcs_cor_continous-related-link/rcs_cor_continous-related-link.component.js